import gql from 'graphql-tag';

export const MRO_SAVE_SEARCH_WORDS = gql`
  mutation SaveSearchWords($words: String!, $limit: Int!, $offset: Int!) {
    insert_search_statistics(objects: {words: $words, offset: $offset, limit: $limit}) {
      affected_rows
      __typename
    }
  }
`;

export const MRO_SAVE_ITEM_VISIT = gql`
  mutation SaveItemVisit($itemId: uuid!) {
    insert_item_visits(objects: {item_id: $itemId}) {
      affected_rows
      __typename
    }
  }
`;



// WEBPACK FOOTER //
// ./src/store/graphql/mutations/cat4mro.js